import RouteLayout from "./RouteLayout";

export default RouteLayout;
